import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {showNotification as showNotificationAction, refreshView as refreshViewAction, SelectInput} from 'react-admin';
import fetchApi from "../../fetchApi";
import PopupDialog from "../../components/PopupDialog";
import UnitsInput from "../../fields/UnitsInput";
import { Form } from 'react-final-form'
import find from 'lodash/find';
import { TextField, Labeled } from 'react-admin';

const transferBalanceChoices = [
    { id: 'FUND', name: 'Fund'},
    { id: 'EXTRA', name: 'Extra'},
    { id: 'EXTRA_TOP', name: 'Extra to all correct'},
];

class TransferBalanceButton extends Component {
    constructor(props) {
        super(props);

        this.state = {submitting: false, open: false}
    }
    handleConfirm = (values) => {
        const { balance, record, showNotification, refreshView } = this.props;

        this.setState({submitting: true})
        fetchApi(record._links.transferBalance.href, {
            method: 'POST',
            body: JSON.stringify({
                fromBalance: balance,
                ...values
            })
        }).then(() => {
            showNotification('Balance transferred', 'info');

            refreshView();
            this.setState({submitting: false})
        }).catch((e) => {
            showNotification('Error transferring balance', 'error');
            this.setState({submitting: false})
        });
    };

    handleClose = () => {
        this.setState({open: false})
    }

    handleOpen = () => {
        this.setState({open: true})
    }

    render() {
        const {balance} = this.props;
        const {submitting, open} = this.state;

        const fromBalanceEntry = find(transferBalanceChoices, c => c.id === balance)

        const fromBalanceName = fromBalanceEntry ? fromBalanceEntry.name : balance;

        return <div>
                <Form initialValues={{units: "0", fromBalance: balance, toBalance: null}} onSubmit={this.handleConfirm} render={({ handleSubmit}) =>
                  <form onSubmit={handleSubmit}>
                      <PopupDialog open={open} onOk={handleSubmit} onClose={this.handleClose} title={`Transfer Balance`}>
                          <div style={{display: 'flex', flexDirection: 'column'}}>
                              <Labeled label={'From'}>
                                  <TextField source={"v"} record={{"v": fromBalanceName}}/>
                              </Labeled>
                              <SelectInput source={'toBalance'} label={'To'} choices={transferBalanceChoices.filter(c => c.id !== balance)}/>
                              <UnitsInput type={'numeric'} source={'units'}/>
                          </div>
                      </PopupDialog>
                  </form>
                }/>
                <Button variant={'contained'} color={'primary'} disabled={submitting} onClick={this.handleOpen}>Transfer</Button>
                <span style={{visibility: !submitting ? 'hidden' : 'visible'}}><CircularProgress/></span>
            </div>;
    }
}

TransferBalanceButton.propTypes = {
    record: PropTypes.object,
    showNotification: PropTypes.func,
    refreshView: PropTypes.func,
    balance: PropTypes.string
};

export default connect(null, {
    showNotification: showNotificationAction,
    refreshView: refreshViewAction,
})(TransferBalanceButton)